module.exports = __webpack_public_path__ + "2f5543a71803e2180112d4b8e11876e2.svg";